import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import {
  REPORT_UPLOAD,
  REPORT_VALIDATE
} from "./actionTypes"

import {
  reportUploadSuccess,
  reportUploadFail,
  reportValidateFail,
  reportValidateSuccess
} from "./actions"

import { reportUpload, reportValidate } from "../../helpers/backend_helper"
import { isEmpty } from "lodash"

function* reportValidateSaga({ payload: report }) {
  try {
    console.log("inside reportValidateSaga new updated:::" + report)
    const response = yield call(reportValidate, report)
    yield put(reportValidateSuccess(response))
  } catch (error) {
    console.log("reportValidateSaga error object")
    console.log(error)
    if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
      console.log("reportValidateSaga error.response object")
      console.log(error.response)
      console.log(error.response.data)
      yield put(reportValidateFail(error.response.data))
    } else {
      yield put(reportValidateFail(error.message))
    }
  }
}

function* reportUploadSaga({ batchId }) {
  try {
    console.log("inside reportUploadSaga ::::::::: now :::::::::")
    console.log(batchId)
    const response = yield call(reportUpload, { batchId })
    yield put(reportUploadSuccess(response))
  } catch (error) {
    if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
      yield put(reportUploadFail(error.response.data.message))
    } else {
      yield put(reportUploadFail(error.message))
    }
  }
}

function* tasksSaga() {
  yield takeEvery(REPORT_VALIDATE, reportValidateSaga)
  yield takeEvery(REPORT_UPLOAD, reportUploadSaga)
}

export default tasksSaga
